<template>
  <a-spin :spinning="spinning">
    <a-form :form="form">
      <a-form-item>
        <a-input
          type="hidden"
          name="pid"
          v-decorator="[
            'pid',
            {
              initialValue: pid,
              rules:
                [
                  { required: true, message: '请输入名称' }
                ]
            }
          ]"
        />
      </a-form-item>
      <a-form-item label="标题" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-input
          v-decorator="['title', { rules: [{ required: true, message: '请输入名称' }] }]"
          name="title"
          placeholder="请输入名称"
        />
      </a-form-item>
      <a-form-item label="标签" :labelCol="labelCol" :wrapperCol="wrapperCol" help="注：英文逗号隔开">
        <a-textarea
          rows="4"
          name="keywords"
          placeholder="请输入标签"
          help="注：含有子栏目时可以不输入标签"
          v-decorator="['keywords', { rules: [{ message: '请输入目标描述' }] }]"
        />
      </a-form-item>
      <a-form-item label="简介" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-textarea
          rows="4"
          name="description"
          placeholder="请输入简介"
          help="注：含有子栏目时可以不输入简介"
          v-decorator="['description', { rules: [{ message: '请输入简介' }] }]"
        />
      </a-form-item>

      <a-form-item
        label="内容"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        help="注：含有子栏目时可以不输入内容"
      >
        <u-editor name="content" v-decorator="['content', { rules: [{ message: '请输入文章内容' }] }]" />
      </a-form-item>
      <a-form-item label="排序" :labelCol="labelCol" :wrapperCol="wrapperCol" help="默认0，值越大越靠前">
        <a-input-number
          name="order"
          v-decorator="[
            'order',
            {
              initialValue: 0
            }
          ]"
        />
      </a-form-item>
      <a-form-item label="状态" :labelCol="labelCol" :wrapperCol="wrapperCol" help="是否在前端展示，默认展示">
        <a-switch
          checked-children="展示"
          un-checked-children="隐藏"
          name="state"
          v-decorator="[
            'state',
            {
              valuePropName: 'checked',
              initialValue: true
            }
          ]"
        />
      </a-form-item>

    </a-form>
  </a-spin>
</template>

<script>
import pick from 'lodash.pick'
import { UEditor } from '@/components'
import { requestGet, requestData } from '@/api/api'

const apiList = {
    getInfo: '/settings/helps/',
    create: '/settings/helps/create',
    update: '/settings/helps/'
}
const fields = ['title', 'pid', 'content', 'order', 'state', 'keywords', 'description']
export default {
    name: 'ModelForm',
    props: {
        id: {
            type: Number,
            default: null
        },
        pid: {
            type: Number,
            default: 0
        }
    },
    components: {
        UEditor
    },
    data () {
        return {
            spinning: false, // 页面加载
            labelCol: {
                xs: { span: 24 },
                sm: { span: 4 }
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 18 }
            },
            form: this.$form.createForm(this)
        }
    },
    mounted () {
        if (this.$props.id) {
            this.getInfo(this.$props.id) // 获取编辑信息
        }
    },
    methods: {
        /**
         * 获取编辑信息
         * id
         * @param
         */
        getInfo (id) {
            this.spinning = true
            requestGet(apiList.getInfo + id)
                .then(res => {
                    res.result.state = res.result.state === 1
                    this.form.setFieldsValue(pick(res.result, fields))
                })
                .finally(() => {
                    this.spinning = false
                })
        },
        onOk () {
            const {
                form: { validateFields }
            } = this
            return new Promise(resolve => {
                // 回调resolve(true)关闭弹出层
                validateFields((errors, values) => {
                    if (!errors) {
                        const url = this.$props.id ? apiList.update + this.$props.id : apiList.create
                        const methods = this.$props.id ? 'put' : 'post'
                        requestData(url, methods, values)
                                .then(res => {
                                    this.$notification.success({
                                        message: res.msg
                                    })
                                    resolve(true)
                                })
                    }
                })
            })
        },
        onCancel () {
            return new Promise(resolve => {
                resolve(true)
            })
        }
    }
}
</script>

<style lang="less" scoped>
.avatar-uploader > .ant-upload {
    width: 128px;
    height: 128px;
}
.ant-upload-select-picture-card i {
    font-size: 32px;
    color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
    margin-top: 8px;
    color: #666;
}
</style>
